export const ACIDITY_ALKALINITY_NAMES = ["Acidité", "Alcalinité"];

export const hasAcidityAlkalinityParameter = (parameters = []) =>
  parameters.some((parameter) =>
    ACIDITY_ALKALINITY_NAMES.includes(parameter?.name)
  );
